import "./styles/tokens.css";
import "./styles/app.css";
import "./components/mp-button.js";
import "./components/mp-touch-keyboard.js";
import "./components/mp-auth-panel.js";
import "./components/mathpop-app.js";
import { initializeAnalytics } from "./services/analytics.js";

initializeAnalytics();

import { startReleaseUpdater } from "../../../js/services/release-updater.js";
startReleaseUpdater({
  canReload: () =>
    !document.querySelector(
      'form[data-release-dirty="true"], mp-auth-panel button:disabled',
    ),
});
